var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/setting-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "setting-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 20C18.2091 20 20 18.2091 20 16C20 13.7909 18.2091 12 16 12C13.7909 12 12 13.7909 12 16C12 18.2091 13.7909 20 16 20Z",
    stroke: "#292B30",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.66675 17.1733V14.8267C2.66675 13.44 3.80008 12.2933 5.20008 12.2933C7.61341 12.2933 8.60008 10.5867 7.38675 8.49333C6.69341 7.29333 7.10675 5.73333 8.32008 5.04L10.6267 3.72C11.6801 3.09333 13.0401 3.46666 13.6667 4.52L13.8134 4.77333C15.0134 6.86666 16.9867 6.86666 18.2001 4.77333L18.3467 4.52C18.9734 3.46666 20.3334 3.09333 21.3867 3.72L23.6934 5.04C24.9067 5.73333 25.3201 7.29333 24.6267 8.49333C23.4134 10.5867 24.4001 12.2933 26.8134 12.2933C28.2001 12.2933 29.3467 13.4267 29.3467 14.8267V17.1733C29.3467 18.56 28.2134 19.7067 26.8134 19.7067C24.4001 19.7067 23.4134 21.4133 24.6267 23.5067C25.3201 24.72 24.9067 26.2667 23.6934 26.96L21.3867 28.28C20.3334 28.9067 18.9734 28.5333 18.3467 27.48L18.2001 27.2267C17.0001 25.1333 15.0267 25.1333 13.8134 27.2267L13.6667 27.48C13.0401 28.5333 11.6801 28.9067 10.6267 28.28L8.32008 26.96C7.10675 26.2667 6.69341 24.7067 7.38675 23.5067C8.60008 21.4133 7.61341 19.7067 5.20008 19.7067C3.80008 19.7067 2.66675 18.56 2.66675 17.1733Z",
    stroke: "#292B30",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.e7d92236551f04ea73dd462e1c93e1ef.svg";
export { ForwardRef as ReactComponent };